import $ from 'jquery';
import $script from 'scriptjs';

import Navigation from '../components/Navigation';
import LiveSearch from '../components/LiveSearch';
import CartMini from '../components/CartMini';

export default class StaticHeader {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.data = section.data;

    // Header
    this.headerSettings = window.headerJSON;
    this.window = $(window);
    this.body = $('body');
    this.mainHeader = $('.main-header');
    this.minimalHeader = $('.header-minimal', this.el);
    this.mainHeaderWrap = $('.main-header-wrap', this.el);
    this.fullNav = $('nav.full', this.$el);
    this.compactNav = $('nav.compact', this.$el);
    this.slideshow = $('.slideshow', this.$el);
    this.actionLinks = $('.main-header .action-links', this.el);
    this.tools = $('.tools', this.el);
    this.toolsGroup = $('.main-header--tools-group', this.el);
    this.branding = $('.store-title, .logo', this.el);
    this.dropdowns = this.el.querySelectorAll('.dropdown-wrap');

    this.checkDropdown();

    const $scripts = $('[data-scripts]');


    if (!this.body.hasClass('template-index' && this.slideshow.length && (this.slideshow.attr('data-full-width') === 'true'))) {
      if (this.compactNav.length) { this.compactNav.addClass('bordered'); } else { this.compactNav.removeClass('bordered'); }
      if (this.fullNav.length) { this.fullNav.addClass('bordered'); } else { this.fullNav.removeClass('bordered'); }
    }

    if (this.mainHeaderWrap.attr('data-header-alignment') === 'true') {
      this.tools = $('.main-header--tools-left', this.el);
    }

    this.navigation = new Navigation({ el: 'nav.full' });
    $script([
      $scripts.data('shopify-api-url'),
    ], () => {
      this.liveSearch = new LiveSearch(
        this.el.querySelector('[data-live-search]'),
        {
          enabled: this.data.live_search_enabled,
        },
      );
    });

    $('.mini-cart-wrap', this.el).on('click.header', this.toggleMiniCart.bind(this));
    $('.mini-cart.active', this.el).on('click.header', event => event.stopPropagation());

    this.window.on('resize.header', () => this.checkDropdown());

    if (
      this.mainHeaderWrap.attr('data-header-layout') === 'minimal'
      || this.mainHeaderWrap.attr('data-header-layout') === 'minimal-sticky'
    ) {
      document.documentElement.classList.add('header-layout-minimal');
    } else {
      document.documentElement.classList.remove('header-layout-minimal');
    }

    this.cartMini = new CartMini();
  }

  toggleMiniCart(e) {
    e.preventDefault();
    e.stopPropagation();

    this.cartMini.open();
  }

  checkDropdown() {
    for (let i = 0; i < this.dropdowns.length; i++) {
      this.dropdowns[i].classList.remove('dropdown-right');
    }

    for (let i = 0; i < this.dropdowns.length; i++) {
      if(this.dropdowns[i].getBoundingClientRect().right + this.dropdowns[i].offsetWidth > window.innerWidth) {
        this.dropdowns[i].classList.add('dropdown-right');
      } else {
        this.dropdowns[i].classList.remove('dropdown-right');
      }
    }
  }

  onSectionUnload() {
    this.navigation.unload();
    this.liveSearch.unload();
    $('[data-cart-mini-toggle]', this.el).off('click.header');
    $(document).off('navigation-resize.header');
    $('body').off('click.header');
    this.window.off('scroll.header');
    this.window.off('scroll.header');
    this.window.off('resize.header');
    this.window.off('load.header');
    document.documentElement.classList.remove('header-layout-minimal');
  }
}
